import request from "@/utils/request.js";
import { BADGE_WALL } from "./config.js";
import _ from "lodash";

/**
 * 获取成就徽章墙列表(HTTP请求)
 */
// export const getBadgeDataList = () => {
//     return request.get(BADGE_WALL.get_badge_data_list);
// };

/**
 * 获取成就列表(HTTP请求)
 */
export const getAchievementList = () => {
    return request.get(BADGE_WALL.get_achievement_list);
};

/**
 * 成就奖励领取
 * @param {*} id
 */
export const getBadgeReward = (id, token_id = 0) => {
    return request.get(BADGE_WALL.get_badge_reward(id, token_id));
};

/**
 * 成就排行榜
 * @param {*} keyword
 */
export const getBadgeRanking = (keyword) => {
    return request.get(BADGE_WALL.get_achievement_ranking + `?keyword=${keyword}`);
};
